import * as React from 'react';
import manageAlarmsStyle from '../ManageAlarmsStyle';
import { Box, Checkbox, Divider, FormControlLabel, TextField } from '@mui/material';
import * as PXBColors from '@brightlayer-ui/colors';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { DECIMAL_NUMBER, RESTRICT_SPEC_WITHOUT_SPACE_REGEX } from '../../../constants';
import { AlarmConfigData, ManageAlarmConfig } from '../../../types';
//import { useState } from 'react';

export const ConfigureAlarms: React.FC<{
    index: number;
    value: number;
    alarmConfigData: AlarmConfigData | null;
    updateAlarmConfigData: Function;
}> = (props) => {
    const { t } = useLanguageLocale();
    const classes = manageAlarmsStyle();

    const [alarmConfig, setAlarmConfig] = React.useState<ManageAlarmConfig | null>(null);

    const { value, index, ...other } = props;

    const onChangeValues = (val: number | string | boolean, name: string, property?: string): void => {
        if (alarmConfig) {
            const alarmConfigObj: any = { ...alarmConfig };
            if (property === '') alarmConfigObj[`${name}`] = val;
            else alarmConfigObj[`${name}`][`${property}`] = val;
            setAlarmConfig(alarmConfigObj);
            props.updateAlarmConfigData(alarmConfigObj);
        }
    };

    const onNumChange = (
        e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
        name: string,
        property?: string
    ): void => {
        const numValue = e.target.value;
        if (new RegExp(DECIMAL_NUMBER).test(numValue) || numValue === '') {
            onChangeValues(e.target.value, name, property);
        }
    };

    const onTextChange = (
        e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
        name: string,
        property?: string
    ): void => {
        if (RESTRICT_SPEC_WITHOUT_SPACE_REGEX.test(e.target.value)) {
            onChangeValues(e.target.value, name, property);
        }
    };

    const onCheckChange = (val: boolean, name: string, property?: string): void => {
        onChangeValues(val, name, property);
    };

    const handleSeverityCheckChange = (event: any, name: string, property?: string): void => {
        onCheckChange(event.target.checked, name, property);
    };
    // const [color, setColor] = useState("white");
    // function click(): void{
    //     setColor(color);
    // }

    React.useEffect(() => {
        if (props.alarmConfigData) {
            if (props.alarmConfigData.alarmConfigurations.length === 0) {
                const defaultValue: ManageAlarmConfig = {
                    deviceId: '',
                    tagId: '',
                    tagName: '',
                    priority: 9999,
                    type: 'Analog',
                    highCritical: {
                        isChecked: false,
                        limit: 0,
                        message: '',
                    },
                    lowCritical: {
                        isChecked: false,
                        limit: 0,
                        message: '',
                    },
                    highCaution: {
                        isChecked: false,
                        limit: 0,
                        message: '',
                    },
                    lowCaution: {
                        isChecked: false,
                        limit: 0,
                        message: '',
                    },
                    ackHoldOff: {
                        checked: false,
                        time: 0,
                    },
                    rearm: {
                        checked: true,
                        time: 60,
                    },
                    alarmDelay: {
                        checked: false,
                        time: 0,
                    },
                    latching: true,
                    active: false,
                    requestedFrom: 'Remote',
                };
                setAlarmConfig(defaultValue);
            } else setAlarmConfig(props.alarmConfigData?.alarmConfigurations[0].alarmConfiguration);
        }
    }, []);

    return (
        <>
            {alarmConfig && (
                <div
                    role="tabpanel"
                    hidden={value !== index}
                    id={`simple-tabpanel-${index}`}
                    aria-labelledby={`simple-tab-${index}`}
                    {...other}
                    style={{ maxHeight: '62vh', minHeight: '62vh', overflow: 'auto' }}
                >
                    <>
                        <Box className={classes.paddingTextbox}>
                            <TextField
                                inputProps={{ 'data-testid': 'alarm-name', maxLength: 5 }}
                                fullWidth
                                required
                                variant="filled"
                                id="AlarmPriority"
                                label="Alarm Prioirty"
                                value={alarmConfig.priority}
                                onChange={(e): void => {
                                    onNumChange(e, 'priority', '');
                                }}
                            />
                        </Box>
                        <Divider></Divider>
                        <Box sx= {(alarmConfig.highCritical.isChecked)?{ background:PXBColors.red[50]}: {color:'black' }} className={classes.marginpadding8}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={alarmConfig.highCritical.isChecked}
                                        style={(alarmConfig.highCritical.isChecked)?{color: PXBColors.red[500]}:{outlineColor:PXBColors.black}}
                                        data-testid="hi-critical"
                                        value={alarmConfig.highCritical.isChecked}
                                        onChange={(evt): void =>
                                            handleSeverityCheckChange(evt, 'highCritical', 'isChecked')
                                        }
                                    />
                                }
                                label={t('MANAGEALARMS.HICRITICAL')}
                            />
                        </Box>
                        {alarmConfig.highCritical.isChecked && (
                            <>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'limit' }}
                                        fullWidth
                                        required
                                        variant="filled"
                                        id="Limit"
                                        label="Limit"
                                        value={alarmConfig.highCritical.limit}
                                        onChange={(e): void => {
                                            onNumChange(e, 'highCritical', 'limit');
                                        }}
                                    />
                                </Box>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'message' }}
                                        fullWidth
                                        variant="filled"
                                        id="Message"
                                        label="Message"
                                        value={alarmConfig.highCritical.message}
                                        onChange={(e): void => {
                                            onTextChange(e, 'highCritical', 'message');
                                        }}
                                    />
                                </Box>
                            </>
                        )}
                        <Divider></Divider>
                        <Box sx={(alarmConfig.lowCritical.isChecked)?{ background:PXBColors.red[50]}: {color:'black' }}className={classes.marginpadding8}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={alarmConfig.lowCritical.isChecked}
                                        style={(alarmConfig.lowCritical.isChecked)?{color: PXBColors.red[500]}:{outlineColor:PXBColors.black}}
                                        data-testid="gi-critical"
                                        onChange={(evt): void =>
                                            handleSeverityCheckChange(evt, 'lowCritical', 'isChecked')
                                        }
                                        value={alarmConfig.lowCritical.isChecked}
                                    />
                                }
                                label={t('MANAGEALARMS.LOCRITICAL')}
                            />
                        </Box>
                        {alarmConfig.lowCritical.isChecked && (
                            <>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'limit' }}
                                        fullWidth
                                        required
                                        variant="filled"
                                        id="Limit"
                                        label="Limit"
                                        value={alarmConfig.lowCritical.limit}
                                        onChange={(e): void => {
                                            onNumChange(e, 'lowCritical', 'limit');
                                        }}
                                    />
                                </Box>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'message' }}
                                        fullWidth
                                        variant="filled"
                                        id="Message"
                                        label="Message"
                                        value={alarmConfig.lowCritical.message}
                                        onChange={(e): void => {
                                            onTextChange(e, 'lowCritical', 'message');
                                        }}
                                    />
                                </Box>
                            </>
                        )}
                        <Divider></Divider>
                        <Box
                            sx={(alarmConfig.highCaution.isChecked)?{ background:PXBColors.yellow[50]}: {color:'black' }}
                            className={classes.marginpadding8}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={alarmConfig.highCaution.isChecked}
                                        style={(alarmConfig.highCaution.isChecked)?{color: PXBColors.yellow[500]}:{outlineColor:PXBColors.black}}
                                        data-testid="gi-critical"
                                        value={alarmConfig.highCaution.isChecked}
                                        onChange={(evt): void =>
                                            handleSeverityCheckChange(evt, 'highCaution', 'isChecked')
                                        }
                                    />
                                }
                                label={t('MANAGEALARMS.HICAUTION')}
                            />
                        </Box>
                        {alarmConfig.highCaution.isChecked && (
                            <>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'limit' }}
                                        fullWidth
                                        required
                                        variant="filled"
                                        id="Limit"
                                        label="Limit"
                                        value={alarmConfig.highCaution.limit}
                                        onChange={(e): void => {
                                            onNumChange(e, 'highCaution', 'limit');
                                        }}
                                    />
                                </Box>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'message' }}
                                        fullWidth
                                        variant="filled"
                                        id="Message"
                                        label="Message"
                                        value={alarmConfig.highCaution.message}
                                        onChange={(e): void => {
                                            onTextChange(e, 'highCaution', 'message');
                                        }}
                                    />
                                </Box>
                            </>
                        )}
                        <Divider></Divider>
                        <Box
                          sx= {(alarmConfig.lowCaution.isChecked)?{ background:PXBColors.yellow[50]}: {color:'black' }}
                            className={classes.marginpadding8}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={alarmConfig.lowCaution.isChecked}
                                        style={(alarmConfig.lowCaution.isChecked)?{color: PXBColors.yellow[500]}:{outlineColor:PXBColors.black}}
                                        data-testid="gi-critical"
                                        onChange={(evt): void =>
                                            handleSeverityCheckChange(evt, 'lowCaution', 'isChecked')
                                        }
                                        value={alarmConfig.lowCaution.isChecked}
                                    />
                                }
                                label={t('MANAGEALARMS.LOCAUTION')}
                            />
                        </Box>
                        {alarmConfig.lowCaution.isChecked && (
                            <>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'limit' }}
                                        fullWidth
                                        required
                                        variant="filled"
                                        id="Limit"
                                        label="Limit"
                                        value={alarmConfig.lowCaution.limit}
                                        onChange={(e): void => {
                                            onNumChange(e, 'lowCaution', 'limit');
                                        }}
                                    />
                                </Box>
                                <Box className={classes.paddingTextbox}>
                                    <TextField
                                        inputProps={{ 'data-testid': 'message' }}
                                        fullWidth
                                        variant="filled"
                                        id="Message"
                                        label="Message"
                                        value={alarmConfig.lowCaution.message}
                                        onChange={(e): void => {
                                            onTextChange(e, 'lowCaution', 'message');
                                        }}
                                    />
                                </Box>
                            </>
                        )}
                    </>
                </div>
            )}
        </>
    );
};
